/* ---------------------------------------------------------------------------
   RESTYLIT - Filtri in evidenza: tendine e scorrimento della fila

   Il <details is="accordion-details"> del tema sa solo aprirsi e chiudersi da
   solo: in una colonna va benissimo, in una fila di tendine no. Qui si aggiunge
   quello che manca:

   - una sola tendina aperta per volta, chiusura al clic fuori e con Esc;
   - il pannello e' position:fixed, quindi va posizionato a mano sotto il suo
     pulsante. E' fisso e non assoluto perche' la fila scorre in orizzontale e
     un contenitore con overflow taglierebbe qualunque pannello al suo interno;
   - le frecce compaiono solo quando la fila e' piu' larga dello spazio, cioe'
     quando altrimenti finirebbe addosso al conteggio degli articoli.

   La delega e' su document: a ogni filtro applicato il tema ributta giu' l'HTML
   della sezione e i listener attaccati ai singoli elementi sparirebbero.
--------------------------------------------------------------------------- */
(function () {
  const BAR = '.rst-filterbar';
  const GROUP = '.facet-accordion-details';
  const MARGIN = 8;

  function openGroups(except) {
    return Array.from(document.querySelectorAll(BAR + ' ' + GROUP)).filter(
      (el) => el !== except && el.hasAttribute('open')
    );
  }

  // el.open = false passa dal setter del custom element del tema, che anima la
  // chiusura e tiene allineato il suo stato interno: togliere l'attributo a
  // mano lo lascerebbe convinto di essere ancora aperto
  function close(el) {
    if ('open' in el) el.open = false;
    else el.removeAttribute('open');
  }

  function place(group) {
    const summary = group.querySelector('summary');
    const panel = group.querySelector('summary + *');
    if (!summary || !panel) return;

    const rect = summary.getBoundingClientRect();
    panel.style.top = rect.bottom + MARGIN + 'px';
    panel.style.maxHeight = window.innerHeight - rect.bottom - MARGIN * 3 + 'px';

    // prima si allinea a sinistra col pulsante, poi si rientra se sborda:
    // la larghezza va letta dopo aver messo il top, il pannello puo' cambiare
    // altezza e quindi larghezza per via della barra di scorrimento interna
    panel.style.left = rect.left + 'px';
    const width = panel.getBoundingClientRect().width;
    const overflow = rect.left + width - (window.innerWidth - MARGIN * 2);
    if (overflow > 0) panel.style.left = Math.max(MARGIN * 2, rect.left - overflow) + 'px';
  }

  function placeOpen() {
    openGroups().forEach(place);
  }

  document.addEventListener(
    'click',
    (event) => {
      const arrow = event.target.closest(BAR + ' .rst-filterbar__arrow');
      if (arrow) {
        const viewport = arrow.parentElement.querySelector('[data-filterbar-viewport]');
        if (viewport) {
          const step = viewport.clientWidth * 0.8;
          viewport.scrollBy({
            left: arrow.dataset.direction === 'next' ? step : -step,
            behavior: 'smooth',
          });
        }
        return;
      }

      const summary = event.target.closest(BAR + ' ' + GROUP + ' > summary');
      if (summary) {
        const current = summary.parentElement;
        if (!current.hasAttribute('open')) {
          openGroups(current).forEach(close);
          // il tema apre dopo di noi: si posiziona al giro successivo
          requestAnimationFrame(() => place(current));
        }
        return;
      }

      // clic dentro una tendina aperta: e' una spunta, non una chiusura
      if (event.target.closest(BAR + ' ' + GROUP + '[open]')) return;

      openGroups().forEach(close);
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = openGroups();
    if (!open.length) return;
    open.forEach(close);
    const summary = open[0].querySelector('summary');
    if (summary) summary.focus();
  });

  // la barra strumenti e' sticky: scorrendo la pagina si sposta di qualche
  // pixel quando l'header si aggancia, e il pannello deve seguirla
  window.addEventListener('scroll', placeOpen, { passive: true });
  window.addEventListener('resize', placeOpen);

  function refresh() {
    document.querySelectorAll(BAR).forEach((bar) => {
      const viewport = bar.querySelector('[data-filterbar-viewport]');
      if (!viewport) return;

      const max = viewport.scrollWidth - viewport.clientWidth;
      // 2px di tolleranza: con lo zoom del browser le larghezze arrivano
      // frazionarie e l'ultima freccia non si spegnerebbe mai
      bar.classList.toggle('rst-filterbar--scrollable', max > 2);
      bar.querySelectorAll('.rst-filterbar__arrow').forEach((arrow) => {
        arrow.disabled =
          arrow.dataset.direction === 'next'
            ? viewport.scrollLeft >= max - 2
            : viewport.scrollLeft <= 2;
      });

      if (!viewport.dataset.bound) {
        viewport.dataset.bound = '1';
        viewport.addEventListener('scroll', refresh, { passive: true });
      }

    });
  }

  // il tema puo' stampare certi gruppi gia' aperti (impostazione "Gruppi di
  // filtri espansi"): nella colonna ha senso, in una fila di tendine no
  function closeAll() {
    openGroups().forEach(close);
  }

  window.addEventListener('resize', refresh);
  // il tema lancia questo a fine ridisegno della collezione: si ricontrolla
  // se la fila e' ancora piu' larga dello spazio
  document.addEventListener('collection:rerendered', () => {
    refresh();
    closeAll();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      refresh();
      closeAll();
    });
  } else {
    refresh();
    closeAll();
  }
})();
